/* ===========================================================================
   ROVE NEXT — the cart tells you when the WHOLE order arrives. 1 Sept 2026.

   Rove ships an order complete: it leaves when the last item is ready. So a
   basket holding an in-stock pillow and a pre-order sofa arrives on the SOFA's
   date, and nothing on the cart said so. A customer would reasonably expect the
   pillow next week.

   Every pre-order line carries two properties written by the buy box:

       Estimated to ship   the ship window a customer was shown, e.g. "Dec 1-8"
       _preorder_eta       its late end, machine-readable, e.g. "2026-12-08"
                           (leading underscore = Shopify hides it from display)

   Before 2 October 2026 these were an ARRIVAL window under the name
   "Estimated arrival". They are a SHIP window now, so the note says ship.

   This reads _preorder_eta off every line, takes the LATEST, and states the
   whole-order date above the checkout button. The wording is Sharon's.

   Deliberately does not touch sections/main-cart.liquid. That is a stock
   Shopify section and a theme update would overwrite anything added to it;
   this file is ours and survives. It anchors to the checkout button because
   that exists in both the cart page and the drawer, whatever the markup
   around it looks like.
   =========================================================================== */
(function () {
  var LEAD    = 'Your order ships complete once every item is in. Estimated to ship ';
  var CONTACT = 'Need part of your order sooner? Contact us.';
  var CONTACT_HREF = '/pages/contact';
  var MARK    = 'data-rn-po-note';
  var M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var WINDOW = 7;             /* keep in step with po_window on the buy box */
  var SHOWN = 'Estimated to ship'; /* the buy box's po_prop: the window as that line's shopper saw it */

  function parse(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) return null;
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    return isNaN(d.getTime()) ? null : d;
  }

  function range(to) {
    var from = new Date(to.getTime());
    from.setUTCDate(from.getUTCDate() - WINDOW);
    /* worded exactly as the buy box words it: "Dec 1–8", "Nov 28–Dec 5" */
    return M[from.getUTCMonth()] + ' ' + from.getUTCDate() + '–' +
           (from.getUTCMonth() === to.getUTCMonth() ? '' : M[to.getUTCMonth()] + ' ') +
           to.getUTCDate();
  }

  /* the whole order moves to the last item to arrive. Since 28 Oct 2026 a
     batch line's window is wider (+2 to +14) than a container line's (+2 to
     +9), so "late end minus WINDOW" no longer always rebuilds what was shown:
     that line's own text is used when it has one, the rebuild only when not. */
  function latest(cart) {
    var out = null;
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var d = parse(props._preorder_eta);
      if (d && (!out || d > out.date)) out = { date: d, text: props[SHOWN] || '' };
    });
    return out;
  }

  function build(text) {
    var box = document.createElement('div');
    box.setAttribute(MARK, '');
    box.style.cssText =
      'margin:0 0 14px;padding:12px 14px;border-radius:4px;' +
      'background:#F2EFE8;border:1px solid rgba(26,23,18,.14);' +
      'font-size:13.5px;line-height:1.5;color:rgba(26,23,18,.78)';
    var one = document.createElement('div');
    one.appendChild(document.createTextNode(LEAD));
    var b = document.createElement('b');
    b.style.cssText = 'font-weight:600;color:#1A1712';
    b.textContent = text;
    one.appendChild(b);
    box.appendChild(one);
    var two = document.createElement('div');
    two.style.cssText = 'margin-top:6px;font-size:12.5px;opacity:.85';
    two.appendChild(document.createTextNode(CONTACT.replace(' Contact us.', ' ')));
    var a = document.createElement('a');
    a.href = CONTACT_HREF;
    a.textContent = 'Contact us';
    a.style.cssText = 'color:inherit;text-decoration:underline';
    two.appendChild(a);
    two.appendChild(document.createTextNode('.'));
    box.appendChild(two);
    return box;
  }

  function clear() {
    var old = document.querySelectorAll('[' + MARK + ']');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
  }

  function place(text) {
    clear();
    /* the checkout button is the one landmark present in both the cart page and
       the drawer; anchoring to it avoids depending on theme class names */
    var buttons = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var anchor = buttons[i].closest('form') || buttons[i];
      if (!anchor || !anchor.parentNode) continue;
      anchor.parentNode.insertBefore(build(text), anchor);
    }
  }

  var busy = false, timer = null;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        busy = false;
        if (!cart) return;
        var when = latest(cart);
        if (when) place(when.text || range(when.date)); else clear();
      })
      .catch(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  function init() {
    refresh();
    /* the drawer mounts late and quantities change in place, so watch rather
       than assume a single render */
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.querySelector && (n.querySelector('[name="checkout"]') ||
                (n.matches && n.matches('[name="checkout"]')))) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('change', schedule, true);
    document.addEventListener('submit', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
